<script lang="ts" setup>
  import { route } from '../../../shared/config/routes.ts';
  import GameAbandonedView from './GameAbandonedView.vue';
</script>

<template>
  <GameAbandonedView @go-to-start="$router.push({ name: route.index })" />
</template>
